export const isPostcodeRequired = (countryKey, countriesArray) => {
  if (!countryKey || !countriesArray) {
    return false;
  }

  const country = countriesArray.find(c => c.countryKey === countryKey);
  return !!country?.isPostcodeRequired;
};
